// agent/sign-in

import { lazy } from 'react';
import AgentLeadWrapper from './AgentLeadWrapper';

const Merchant = lazy(() => import('./MerchantPage'));

const AgentLeadConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'agent/sign-in',
      element: (
        <AgentLeadWrapper>
          <Merchant />,
        </AgentLeadWrapper>
      ),
    },
  ],
};

export default AgentLeadConfig;
